import styled from "styled-components";
import { StyledScreen } from '~common/screen';

export const Container = styled.div`
  margin: 0 auto;
  
  @media (min-width: 980px) {
    width: 940px;
    flex-direction: row;
    display: flex;
  }
`

export const Col = styled.div`
  @media (min-width: 980px) {
    flex: 0 0 50%;
  }
`

export const Title = styled(StyledScreen.TitleH2)`
  text-align: left;
  margin-bottom: 24px;
`

export const Text = styled.div`
  font-size: 18px;
  line-height: 170%;
  color: #2A2637;
  margin: 0 0 24px;
`

export const Badges = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  @media (min-width: 414px) {
    justify-content: flex-start;
  }
`

export const Badge = styled.div`
  img {
    width: 152px;
    height: auto;
  }
  
  @media (min-width: 320px) {
    img {
      width: 100%;
    }
  }
  
  @media (min-width: 414px) {
    margin-right: 33px;

    &:last-child {
      margin-right: 0;
    }

    img {
      width: 162px;
    }
  }
`

export const Icon = styled.div`
  background: rgb(207, 239, 248);
  border-radius: 20px;
  height: 93px;
  position: relative;
  margin: 100px 0 36px;
  
  @media (min-width: 980px) {
    height: 266px;
    border-radius: 80px;
    margin: 0;
  }
`

export const IconImage = styled.div`
  position: absolute;
  left: 68px;
  bottom: 28px;
  
  img {
    width: 65px;
    height: auto;
    vertical-align: middle;
  }
  
  @media (min-width: 980px) {
    left: 78px;
    bottom: auto;
    top: 50%;
    transform: translateY(-50%);
    
    img {
      width: 198px;
      height: 352px;
    }
  }
`

export const IconImageRating = styled.div`
  position: absolute;
  left: 163px;
  top: 10px;
  transform: translateY(-50%);
  img {
    width: 85px;
    height: 61px;
  }

  @media (min-width: 375px) {
    top: 10px;
  }
  
  @media (min-width: 980px) {
    left: auto;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    img {
      width: 168px;
      height: 107px;
    }
  }
`